import React, { FormEvent, useEffect, useState } from "react";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

import PasswordField from "../../atoms/PasswordField/PasswordField";
import Logo from "../../../assets/logo_siscap.svg";
import styles from "./Login.module.css";
import { changeRequiredPassword } from "../../../API/apiAuth";
import { useAuth } from "../../../resources/AuthProvider";

const ForcePasswordChange: React.FC = () => {
  const navigate = useNavigate();
  const { clearRequiredPasswordChange, logout } = useAuth();
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [msgError, setMsgError] = useState<string | null>(null);
  const [msgSuccess, setMsgSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!msgError) return;
    const timer = setTimeout(() => setMsgError(null), 5000);
    return () => clearTimeout(timer);
  }, [msgError]);

  const handleSubmit = async (event?: FormEvent) => {
    event?.preventDefault();
    setMsgError(null);
    setMsgSuccess(null);

    if (!oldPassword) {
      setMsgError("Por favor, informe a senha temporária.");
      return;
    }

    if (!password) {
      setMsgError("Por favor, informe a nova senha.");
      return;
    }

    if (!passwordConfirmation) {
      setMsgError("Por favor, confirme a nova senha.");
      return;
    }

    if (password !== passwordConfirmation) {
      setMsgError("As senhas informadas não coincidem.");
      return;
    }

    try {
      setLoading(true);
      const message = await changeRequiredPassword({
        old_password: oldPassword,
        password,
        password_confirmation: passwordConfirmation,
      });

      clearRequiredPasswordChange();
      setMsgSuccess(message);
      setTimeout(() => {
        logout();
        navigate("/login", { replace: true });
      }, 800);
    } catch (error: any) {
      setMsgError(error?.message || "Não foi possível alterar a senha.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.cardRight}>
          <div className={styles.divImage3}>
            <img src={Logo} alt="SISCAP" className={styles.cadeado} />
          </div>
          <h2 className={`${styles.title} ${styles.titleCentered}`}>Alteração obrigatória de senha</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            {msgError && (
              <div className={styles.inputGroup}>
                <Alert severity="error">{msgError}</Alert>
              </div>
            )}
            {msgSuccess && (
              <div className={styles.inputGroup}>
                <Alert severity="success">{msgSuccess}</Alert>
              </div>
            )}

            <div className={styles.inputGroup}>
              <label className={styles.titleInput2}>Senha temporária</label>
              <PasswordField
                testeid="oldPassword"
                fullWidth
                label=""
                isLogin={false}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                margin="normal"
                variant="standard"
                customClassName={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.titleInput2}>Nova senha</label>
              <PasswordField
                testeid="newPassword"
                fullWidth
                label=""
                isLogin={false}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
                variant="standard"
                customClassName={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.titleInput2}>Confirmar nova senha</label>
              <PasswordField
                testeid="confirmNewPassword"
                fullWidth
                label=""
                isLogin={false}
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                margin="normal"
                variant="standard"
                customClassName={styles.input}
              />
            </div>

            <div className={styles.blButtons}>
              <div className={styles.buttonGroup}>
                <button
                  type="submit"
                  disabled={loading}
                  className={`${styles.button} ${loading ? styles.buttonLoad : ""}`}
                >
                  {loading ? (
                    <>
                      <div className={styles.spinner}></div>
                      <span>Salvando...</span>
                    </>
                  ) : (
                    <span>Alterar Senha</span>
                  )}
                </button>
              </div>
              <div className={styles.buttonGroup}>
                <button
                  type="button"
                  className={`${styles.button2} ${loading ? styles.buttonOpacity : ""}`}
                  disabled={loading}
                  onClick={() => {
                    logout();
                    navigate("/login", { replace: true });
                  }}
                >
                  Voltar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
